module.exports = __webpack_public_path__ + "img/IMG-20200624-WA0006.5391e78b.jpg";